import React from 'react';
import * as yup from 'yup';
import FormSection from '../../../../common/hookFormComponents/FormSection';

const fields = [
  {
    colSpan: 1,
    name: 'currentAmount',
    type: 'text',
    label: 'Receivable Amount',
    isRequired: true,
  },
];

export const amountsFieldsValidation = {
  [fields[0].name]: yup
    .number()
    .typeError(`${fields[0].label} must be a number`)
    .integer()
    .positive()
    .required()
    .label(fields[0].label),
};

const AmountsSection = (props) => {
  return <FormSection sectionColumn={1} formFields={fields} {...props} />;
};

export default AmountsSection;
